import React from 'react';
import Template from './template';

const Header = () => {
  return (
    <Template />
  );
};

export default Header;